import React from 'react'

import { SectionContainer, SectionTitle, DownloadLinks } from '../../_common'

import { lightTheme } from '../../../App.theme'
import { Typography } from '@material-ui/core'

import useStyles from './styles'

const Empresas = () => {
  const { titleClass } = useStyles()

  const links = [
    {
      title: 'Ley federal del trabajo',
      path: 'http://www.diputados.gob.mx/LeyesBiblio/pdf/125_020719.pdf',
      external: true,
    },
    {
      title: 'Ley del IMSS',
      path:
        'http://www.diputados.gob.mx/LeyesBiblio/pdf_mov/Ley_del_Seguro_Social.pdf',
      external: true,
    },
    {
      title: 'Ley de impuesto sobre la renta',
      path: 'http://www.diputados.gob.mx/LeyesBiblio/pdf/LISR_091219.pdf',
      external: true,
    },
    {
      title: 'Comparativo NIF D-3 2015 y la nueva NIF D-3 2016',
      path: '../../../assets/comparativa-NIF.docx',
      external: false,
    },
  ]

  return (
    <SectionContainer
      sectionID="empresas"
      backgroundColor={lightTheme.palette.extras.slate}
    >
      <SectionTitle title="Empresas" />
      <Typography className={titleClass}>Descargas</Typography>
      <DownloadLinks light {...{ links }} />
    </SectionContainer>
  )
}

export default Empresas
